import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/css/global.css'
import axios from 'axios'
import permissionDirective from './directives/permission'

Vue.prototype.apiUrl = '/api'

axios.defaults.baseURL = '/api';
axios.defaults.timeout = 10000;
//请求拦截器
axios.interceptors.request.use(function (config) {
    config.headers.Authorization = localStorage.getItem('adminToken');
    return config
}, function (err) {
    console.error('请求错误:', err);
    return Promise.reject(err);
})
//响应拦截器
axios.interceptors.response.use(function (res) {
    // 只有当API返回错误状态码时，才返回被拒绝的Promise
    // 对于403错误，只显示错误信息，不拒绝Promise
    if (res.data.code == 403) {
        Vue.prototype.$message.error("请先登录");
        // 不返回被拒绝的Promise，避免正常请求被当作错误处理
        return res;
    } else {
        return res
    }
}, function (err) {
    console.error('响应错误:', err);
    Vue.prototype.$message.error("网络错误，请稍后重试");
    return Promise.reject(err);
})

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

// 引入富文本组件
import QuillEditor from 'vue-quill-editor'
// 引入富文本组件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(QuillEditor)
Vue.use(permissionDirective)


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
